/* ==========================================================================
   Celyssia UK/US - Moon Bundle global bra size selector
   CareLift

   Design rule that drives this whole file:

     WE NEVER MOVE OR REMOVE A NODE MOON BUNDLE OWNS.

   The previous build lifted each unit's size selector out of its
   .moonbundle-variant-row and re-parented it into our gold panel. Moon
   Bundle still believed that node was its child. The next time it patched
   the row it tried to insert or remove relative to a child that was no
   longer there, the patch failed, and the recovery path rebuilds the whole
   unit list from scratch - every row back to its default variant. That is
   why all the units land on the SAME colour rather than three scrambled
   ones, and why it only bites above one unit.

   Here the selectors stay exactly where Moon Bundle put them. We hide the
   size one with CSS and echo it as a read-only chip inside our own panel,
   which is the only node we add - appended, never moved.

   Adds the "Find my size" quiz (same 4-question flow as LaceLift), wired
   into this file's own panel and size map. Everything else - the size
   map, guide images, gallery freeze, late watch, reconcile logic - is
   unchanged from the SoftLift build this file was derived from.
   ========================================================================== */

(function () {
  "use strict";

  const PRODUCT = "CareLift";

  /* One page, one size map. If a second product's script ever loads alongside
     this one the first would silently win and size customers against the
     wrong chart, so say so loudly rather than fail quietly. */
  if (window.__mbBraSelectorLoaded) {
    if (window.__mbBraProduct && window.__mbBraProduct !== PRODUCT) {
      console.warn(
        "[celyssia] " + PRODUCT + " size selector did not start: " +
        window.__mbBraProduct + " is already running on this page. Load only one."
      );
    }

    return;
  }

  window.__mbBraSelectorLoaded = true;
  window.__mbBraProduct = PRODUCT;

  /* Flip to true, reproduce on a multi-unit tier, and read the console.
     Every read, every correction and every give-up is traced. */
  const MB_DEBUG = false;

  function mbLog() {
    if (!MB_DEBUG) return;
    console.log.apply(console, ["[celyssia]"].concat(Array.prototype.slice.call(arguments)));
  }

  /* ----------------------------------------------------------------------
     Size mapping - guide CARELIFT_US (US / Canada / UK / Ireland).
     Bands 30-48, cups A to H/I, ceiling 4XL, 63 cells, copied cell by
     cell (same grid as FirmLift). A runs 32-38, B 30-40, C to DDD/F the full width, G 34-46 and
     H/I 34-44. NOTE: this chart maps cells to 4XL, so the product needs a
     4XL variant or those cells will fail with "We could not set 4XL on
     every bra". Empty cells on the guide are absent here on purpose.
     ---------------------------------------------------------------------- */

  const BRA_SIZE_MAP = {
    "32A": "S", "34A": "S", "36A": "M", "38A": "L",

    "30B": "S", "32B": "S", "34B": "S", "36B": "M", "38B": "L", "40B": "L",

    "30C": "S", "32C": "S", "34C": "M", "36C": "M", "38C": "L", "40C": "XL", "42C": "2XL", "44C": "2XL", "46C": "3XL", "48C": "3XL",

    "30D": "S", "32D": "M", "34D": "M", "36D": "L", "38D": "XL", "40D": "XL", "42D": "2XL", "44D": "3XL", "46D": "3XL", "48D": "4XL",

    "30DD/E": "M", "32DD/E": "M", "34DD/E": "L", "36DD/E": "L", "38DD/E": "XL", "40DD/E": "2XL", "42DD/E": "2XL", "44DD/E": "3XL", "46DD/E": "4XL", "48DD/E": "4XL",

    "30DDD/F": "M", "32DDD/F": "M", "34DDD/F": "L", "36DDD/F": "XL", "38DDD/F": "XL", "40DDD/F": "2XL", "42DDD/F": "3XL", "44DDD/F": "3XL", "46DDD/F": "4XL", "48DDD/F": "4XL",

    "34G": "L", "36G": "XL", "38G": "2XL", "40G": "3XL", "42G": "3XL", "44G": "4XL", "46G": "4XL",

    "34H/I": "L", "36H/I": "XL", "38H/I": "3XL", "40H/I": "3XL", "42H/I": "3XL", "44H/I": "4XL"
  };

  const BAND_OPTIONS = ["30", "32", "34", "36", "38", "40", "42", "44", "46", "48"];
  const CUP_OPTIONS = ["A", "B", "C", "D", "DD/E", "DDD/F", "G", "H/I"];

  /* CareLift keeps the pink panel. LaceLift is gold (#C3A46A). Change these
     two if the products should match on the storefront. */
  const PANEL_BG = "#EAC8BA";
  const GUIDE_BG = "#f8eee9";

  const SIZE_GUIDE_IMAGES = {
    en: "https://cdn.shopify.com/s/files/1/0304/7476/4426/files/CARELIFT_US_2268bc2b-1b17-4cad-8d80-b0955c8df665.png?v=1792220042",
    aus: "https://cdn.shopify.com/s/files/1/0304/7476/4426/files/CARELIFT_AU_7eb7c4ac-ec25-4063-981b-4373bad6a770.png?v=1792220044"
  };

  const PRODUCT_LABEL = "CareLift";

  /* The guide says it plainly: between two sizes, take the smaller one. */
  const ROUNDING = "down";
  const ROUNDING_TEXT = "Between two sizes? Take the smaller one.";

  /* Last size applied (quiz result or a manual pick). Used to put the same
     size back on any tier Moon Bundle rebuilds afterwards - e.g. when she
     switches from the 2-pack to the 3-pack - without redoing the quiz. */
  const MB_QUIZ_APPLIED = { band: "", cup: "" };

  /* Which option is the size and which is the colour is read from the label
     Moon Bundle prints above each selector. Position is a guess that breaks
     the day the option order changes on one product. */
  const SIZE_NAME_KEYS = ["SIZE", "TAILLE"];
  const COLOUR_NAME_KEYS = ["COLOR", "COLOUR", "COULEUR"];

  let isUpdating = false;
  let stylesInjected = false;
  let observer = null;
  let rescanTimer = null;

  /* ----------------------------------------------------------------------
     Small helpers
     ---------------------------------------------------------------------- */

  function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function waitFor(fn, timeout, interval) {
    const max = timeout || 600;
    const step = interval || 16;

    return new Promise(resolve => {
      const start = Date.now();

      (function check() {
        let result = null;

        try {
          result = fn();
        } catch (e) {
          result = null;
        }

        if (result) return resolve(result);
        if (Date.now() - start >= max) return resolve(null);

        setTimeout(check, step);
      })();
    });
  }

  function normalizeText(text) {
    return (text || "").replace(/\s+/g, " ").trim().toUpperCase();
  }

  function getOffers() {
    return Array.from(document.querySelectorAll(".moonbundle-option-wrapper"));
  }

  function getRows(offer) {
    if (!offer) return [];
    return Array.from(offer.querySelectorAll(".moonbundle-variant-row"));
  }

  /* ----------------------------------------------------------------------
     Telling the size selector from the colour selector
     ---------------------------------------------------------------------- */

  function selectorName(selector) {
    const raw = selector.querySelector(".moonbundle-option-name");
    return normalizeText(raw && raw.textContent).replace(/[:*]/g, "").trim();
  }

  function classifyRow(row) {
    const selectors = Array.from(row.querySelectorAll(".moonbundle-option-selector"));

    let size = null;
    let colour = null;

    selectors.forEach(selector => {
      const name = selectorName(selector);

      if (!size && SIZE_NAME_KEYS.some(key => name.indexOf(key) !== -1)) {
        size = selector;
        return;
      }

      if (!colour && COLOUR_NAME_KEYS.some(key => name.indexOf(key) !== -1)) {
        colour = selector;
      }
    });

    /* Fall back to position only when the labels are missing entirely. */
    if (!size && selectors.length >= 2) size = selectors[selectors.length - 1];
    if (!colour && selectors.length >= 2 && selectors[0] !== size) colour = selectors[0];

    return { size: size, colour: colour, selectors: selectors };
  }

  /* Adding a class is not a structural change, so it cannot break a patch.
     If Moon Bundle overwrites className on re-render we simply re-tag on the
     next observer tick. */
  function tagSizeSelectors(offer) {
    getRows(offer).forEach(row => {
      const parts = classifyRow(row);

      if (parts.size && !parts.size.classList.contains("mb-is-size")) {
        parts.size.classList.add("mb-is-size");
      }
    });
  }

  /* ----------------------------------------------------------------------
     Driving a Moon Bundle dropdown

     findOption never searches the whole document for the first element whose
     text matches. With one dropdown on screen that is harmless. With three or
     six identical ones it means unit 3's click can land in unit 1's option
     list, which changes unit 1's variant and makes Moon Bundle rebuild it.
     ---------------------------------------------------------------------- */

  function optionNodesIn(root) {
    return Array.from(root.querySelectorAll('[role="option"], .moonbundle-dropdown-item'));
  }

  function findOption(dropdownRoot, target, before) {
    if (!dropdownRoot || !dropdownRoot.isConnected) return null;

    const wanted = normalizeText(target);

    /* 1. Inside this selector. */
    let hit = optionNodesIn(dropdownRoot).find(el => normalizeText(el.textContent) === wanted);

    if (hit) return hit;

    /* 2. A list this button explicitly owns, if Moon Bundle portals it out. */
    const button = dropdownRoot.querySelector(".moonbundle-dropdown-button");
    const ownedId = button && (button.getAttribute("aria-controls") || button.getAttribute("aria-owns"));

    if (ownedId) {
      const owned = document.getElementById(ownedId);

      if (owned) {
        hit = optionNodesIn(owned).find(el => normalizeText(el.textContent) === wanted);
        if (hit) return hit;
      }
    }

    /* 3. Last resort: only options that did not exist before we clicked, so
          the match has to be a consequence of this specific click. */
    if (before) {
      hit = optionNodesIn(document)
        .filter(el => !before.has(el))
        .find(el => normalizeText(el.textContent) === wanted);

      if (hit) return hit;
    }

    return null;
  }

  function readDropdown(dropdownRoot) {
    if (!dropdownRoot || !dropdownRoot.isConnected) return "";

    const span = dropdownRoot.querySelector(".moonbundle-dropdown-selected span");
    return normalizeText(span && span.textContent);
  }

  async function selectDropdownValue(dropdownRoot, targetValue) {
    if (!dropdownRoot || !dropdownRoot.isConnected || !targetValue) return false;

    const button = dropdownRoot.querySelector(".moonbundle-dropdown-button");

    if (!button) return false;

    const target = normalizeText(targetValue);

    if (readDropdown(dropdownRoot) === target) return true;

    const before = new Set(optionNodesIn(document));

    button.click();

    const match = await waitFor(() => findOption(dropdownRoot, target, before), 500, 16);

    if (!match) {
      document.body.click();
      return false;
    }

    match.click();

    await waitFor(
      () => !dropdownRoot.isConnected || readDropdown(dropdownRoot) === target,
      300,
      16
    );

    /* A detached node is a failure, not a success. The row was rebuilt and
       whatever we just clicked belongs to a tree nobody is looking at. */
    if (!dropdownRoot.isConnected) return false;

    return readDropdown(dropdownRoot) === target;
  }

  /* ----------------------------------------------------------------------
     Reading and restoring a unit's colour

     Colour can be a dropdown or a swatch strip depending on how the offer is
     configured, so both are handled.
     ---------------------------------------------------------------------- */

  function swatchNodes(colourSelector) {
    return Array.from(
      colourSelector.querySelectorAll(
        '.moonbundle-swatch-buttons > *, [role="radio"], button'
      )
    );
  }

  function isActiveSwatch(el) {
    if (!el) return false;

    if (el.getAttribute("aria-checked") === "true") return true;
    if (el.getAttribute("aria-selected") === "true") return true;
    if (el.getAttribute("aria-pressed") === "true") return true;

    if (el.dataset && (el.dataset.selected === "true" || el.dataset.active === "true")) return true;

    return /(^|\s)(is-)?(active|selected|checked)(\s|$)/i.test(el.className || "");
  }

  function swatchLabel(el) {
    if (!el) return "";

    return normalizeText(
      el.getAttribute("title") ||
      el.getAttribute("aria-label") ||
      (el.dataset && el.dataset.value) ||
      el.textContent
    );
  }

  function readColour(row) {
    const parts = classifyRow(row);

    if (!parts.colour) return { how: "none", label: "", index: -1 };

    const span = parts.colour.querySelector(".moonbundle-dropdown-selected span");

    if (span) {
      return { how: "dropdown", label: normalizeText(span.textContent), index: -1 };
    }

    const swatches = swatchNodes(parts.colour);

    if (swatches.length) {
      const index = swatches.findIndex(isActiveSwatch);

      return {
        how: "swatch",
        label: index >= 0 ? swatchLabel(swatches[index]) : "",
        index: index
      };
    }

    return { how: "unreadable", label: "", index: -1 };
  }

  function colourMatches(row, wanted) {
    if (!wanted || wanted.how === "none" || wanted.how === "unreadable") return true;

    const current = readColour(row);

    if (wanted.label) return current.label === wanted.label;
    if (wanted.how === "swatch") return current.index === wanted.index;

    return true;
  }

  async function restoreColour(row, wanted) {
    if (!row || !row.isConnected) return false;
    if (!wanted || wanted.how === "none" || wanted.how === "unreadable") return true;

    const parts = classifyRow(row);

    if (!parts.colour) return false;

    if (wanted.how === "dropdown") {
      const dropdown = parts.colour.querySelector(".moonbundle-custom-dropdown") || parts.colour;
      return selectDropdownValue(dropdown, wanted.label);
    }

    const swatches = swatchNodes(parts.colour);

    let target = wanted.label
      ? swatches.find(el => swatchLabel(el) === wanted.label)
      : null;

    if (!target && wanted.index >= 0) target = swatches[wanted.index];
    if (!target) return false;
    if (isActiveSwatch(target)) return true;

    target.click();

    await waitFor(() => !row.isConnected || colourMatches(row, wanted), 260, 16);

    if (!row.isConnected) return false;

    return colourMatches(row, wanted);
  }

  /* ----------------------------------------------------------------------
     Reconciliation

     Moon Bundle rebuilds rows when one of them changes, and the order it does
     that in is not observable from out here. A fixed sequence of steps only
     works while the cascade happens to run the same way - fine at two units,
     a coin flip at three, hopeless at six.

     So we stop sequencing. Read the whole tier, correct exactly ONE thing,
     read the whole tier again. That converges under any rebuild order, and it
     is free when nothing drifted: the first read finds every value correct
     and returns without a single click.
     ---------------------------------------------------------------------- */

  function findDrift(offer, mappedSize, savedColours, giveUp) {
    const target = normalizeText(mappedSize);
    const rows = getRows(offer);

    for (let i = 0; i < rows.length; i++) {
      if (giveUp["size:" + i]) continue;

      const sizeSelector = classifyRow(rows[i]).size;

      if (!sizeSelector) continue;

      const dropdown = sizeSelector.querySelector(".moonbundle-custom-dropdown") || sizeSelector;

      if (readDropdown(dropdown) !== target) {
        return { kind: "size", index: i, wanted: mappedSize };
      }
    }

    for (let i = 0; i < rows.length && i < savedColours.length; i++) {
      if (giveUp["colour:" + i]) continue;

      if (!colourMatches(rows[i], savedColours[i])) {
        return { kind: "colour", index: i, wanted: savedColours[i] };
      }
    }

    return null;
  }

  async function reconcile(offer, mappedSize, savedColours) {
    const units = getRows(offer).length;

    /* Six units on the buy-3-get-3 tier need a bigger budget than three. */
    const deadline = Date.now() + Math.min(2500 + units * 2400, 20000);

    const fails = {};
    const hits = {};
    const giveUp = {};

    let oscillating = false;
    let passes = 0;

    mbLog("sync start -", units, "units, size", mappedSize, "colours",
      savedColours.map((c, i) => "#" + (i + 1) + " " + (c.label || c.how)).join(" | "));

    let exhausted = false;

    while (true) {
      /* Running out of time is a FAILURE. The old loop simply fell out of
         the while condition with an empty giveUp map, which reported
         sizeOk:true and lost:[] - a silent lie. */
      if (Date.now() >= deadline) {
        exhausted = true;
        mbLog("out of time after", passes, "passes");
        break;
      }

      passes++;

      const drift = findDrift(offer, mappedSize, savedColours, giveUp);

      if (!drift) break;

      const tag = drift.kind + ":" + drift.index;

      hits[tag] = (hits[tag] || 0) + 1;

      /* Correcting the same unit a fifth time means the widget is undoing us
         as fast as we fix it. No script outside Moon Bundle wins that, and
         spinning to the deadline just leaves her watching a shimmer. */
      if (hits[tag] > 4) {
        oscillating = true;
        mbLog("oscillation on", tag, "- Moon Bundle is resetting sibling units on every change");
        break;
      }

      mbLog("pass", passes, "correcting", tag, "->", (drift.wanted && drift.wanted.label) || drift.wanted);

      let ok = false;

      if (drift.kind === "size") {
        const sizeSelector = classifyRow(getRows(offer)[drift.index] || document.createElement("div")).size;

        if (sizeSelector) {
          const dropdown = sizeSelector.querySelector(".moonbundle-custom-dropdown") || sizeSelector;
          ok = await selectDropdownValue(dropdown, mappedSize);
        }
      } else {
        ok = await restoreColour(getRows(offer)[drift.index], drift.wanted);
      }

      if (!ok) {
        fails[tag] = (fails[tag] || 0) + 1;

        /* Twice refused is not a race, it is a value that does not exist in
           this combination. Stop fighting the widget over it. */
        if (fails[tag] >= 2) {
          giveUp[tag] = true;
          mbLog("giving up on", tag);
        }
      }

      await wait(ok ? 50 : 150);
    }

    if (oscillating || exhausted) {
      for (let guard = 0; guard < savedColours.length + 4; guard++) {
        const drift = findDrift(offer, mappedSize, savedColours, giveUp);

        if (!drift) break;

        giveUp[drift.kind + ":" + drift.index] = true;
      }
    }

    const lost = [];
    let sizeOk = true;

    Object.keys(giveUp).forEach(tag => {
      if (tag.indexOf("size:") === 0) {
        sizeOk = false;
        return;
      }

      const index = parseInt(tag.split(":")[1], 10);
      const saved = savedColours[index];
      const label = (saved && saved.label) || ("Bra " + (index + 1));

      if (lost.indexOf(label) === -1) lost.push(label);
    });

    mbLog("sync done in", passes, "pass(es), sizeOk", sizeOk, "lost", lost);

    return { sizeOk: sizeOk, lost: lost, passes: passes, exhausted: exhausted };
  }

  /* ----------------------------------------------------------------------
     Fast pass

     The reconcile loop is correct but deliberately slow: one correction, then
     a full re-read, because it cannot assume a rebuild order. On six units
     that is a dozen round trips and the customer watches every one.

     So do the obvious work first, in bulk, and let reconcile verify rather
     than discover. Sizes go one at a time because each opens a dropdown and
     two open lists on screen at once is how clicks land in the wrong unit.
     Colours go in a burst: a swatch is a single click with no popup, and a
     colour change does not cascade, so there is nothing to wait for between
     them.

     If any of this is wrong, reconcile catches it. The fast pass is only ever
     an optimisation - never the thing correctness depends on.
     ---------------------------------------------------------------------- */

  async function fastPass(offer, mappedSize, savedColours) {
    const target = normalizeText(mappedSize);
    const count = getRows(offer).length;

    for (let i = 0; i < count; i++) {
      const row = getRows(offer)[i];

      if (!row) continue;

      const sizeSelector = classifyRow(row).size;

      if (!sizeSelector) continue;

      const dropdown = sizeSelector.querySelector(".moonbundle-custom-dropdown") || sizeSelector;

      if (readDropdown(dropdown) === target) continue;

      await selectDropdownValue(dropdown, mappedSize);
    }

    /* The size cascade has to LAND before we put colours back, or we restore
       into a rebuild that is still in flight and it wipes us. Six units spend
       long enough opening dropdowns that this is free; three units do not,
       which is exactly why the small tier broke when it got faster. */
    await wait(300);

    let restored = 0;

    for (let i = 0; i < savedColours.length; i++) {
      const row = getRows(offer)[i];
      const wanted = savedColours[i];

      if (!row || !wanted || wanted.how !== "swatch") continue;
      if (colourMatches(row, wanted)) continue;

      const parts = classifyRow(row);

      if (!parts.colour) continue;

      const swatches = swatchNodes(parts.colour);

      let node = wanted.label
        ? swatches.find(el => swatchLabel(el) === wanted.label)
        : null;

      if (!node && wanted.index >= 0) node = swatches[wanted.index];
      if (!node || isActiveSwatch(node)) continue;

      node.click();
      restored++;

      await wait(35);
    }

    mbLog("fast pass done -", count, "sizes,", restored, "colours re-clicked");
  }

  /* Converging is not the same as being finished. Moon Bundle can queue its
     own re-render and flush it a few hundred milliseconds after our last
     click, by which point the loop has exited and nothing is watching. That
     flush rebuilds the rows from its state and every unit lands on the
     product's default variant. So we keep watching after we think we won. */
  async function reconcileUntilStable(offer, mappedSize, savedColours) {
    await fastPass(offer, mappedSize, savedColours);

    let result = await reconcile(offer, mappedSize, savedColours);

    /* TWO consecutive clean rounds before we believe it. One was what the
       three-unit tier kept passing on: fast enough to converge and leave
       before Moon Bundle's flush had even arrived. */
    let clean = 0;

    for (let round = 1; round <= 4 && clean < 2; round++) {
      await wait(round === 1 ? 300 : 380);

      const drift = findDrift(offer, mappedSize, savedColours, {});

      if (!drift) {
        clean++;
        mbLog("watch round", round, "clean", clean + "/2");
        continue;
      }

      clean = 0;

      mbLog("late re-render on", drift.kind + ":" + drift.index, "- correcting, round", round);

      result = await reconcile(offer, mappedSize, savedColours);
    }

    return result;
  }

  /* ----------------------------------------------------------------------
     Late watch

     Widening the visible watchdog protects against a flush that arrives
     within a second. It does not protect against one that arrives later, and
     making her stare at a shimmer for three seconds to cover that is not a
     trade worth making.

     So once the sync UI clears we keep checking quietly in the background.
     Reads are free. If the page moves on its own we fix it; if she touches
     anything, she wins and we stop immediately.
     ---------------------------------------------------------------------- */

  function cancelLateWatch(offer) {
    if (offer && offer.__mbLateWatch) offer.__mbLateWatch.cancelled = true;
  }

  function startLateWatch(offer, mappedSize, savedColours) {
    cancelLateWatch(offer);

    const token = { cancelled: false };

    offer.__mbLateWatch = token;

    /* Her own click always wins. A programmatic .click() does not emit
       pointerdown, so our own corrections cannot cancel this by accident. */
    const stop = function () {
      token.cancelled = true;
      mbLog("late watch cancelled - customer interacted");
    };

    offer.addEventListener("pointerdown", stop, true);

    (async function () {
      const until = Date.now() + 2500;

      while (Date.now() < until && !token.cancelled) {
        await wait(220);

        if (token.cancelled || isUpdating || !offer.isConnected) break;

        const drift = findDrift(offer, mappedSize, savedColours, {});

        if (!drift) continue;

        mbLog("LATE FLUSH after sync on", drift.kind + ":" + drift.index, "- correcting quietly");

        isUpdating = true;
        document.body.classList.add("mb-bra-syncing");

        const lateFrozen = freezeGallery();

        try {
          await reconcile(offer, mappedSize, savedColours);
        } finally {
          unfreezeGallery(lateFrozen);
          document.body.classList.remove("mb-bra-syncing");
          isUpdating = false;
        }
      }

      offer.removeEventListener("pointerdown", stop, true);

      if (offer.__mbLateWatch === token) offer.__mbLateWatch = null;
    })();
  }

  /* ----------------------------------------------------------------------
     Gallery freeze

     Every variant we set fires the theme's own variant-changed handler, so
     the product gallery swaps to that variant's photo. A dozen corrections on
     a six-bra tier is a dozen photo swaps - it reads as the gallery riffling
     through the catalogue, and each swap is a fetch and a repaint competing
     with our clicks, which is part of why it feels long.

     We cannot stop the theme reacting. We can stop her watching it: cover the
     gallery with the photo that was already showing, then take the cover off.
     One node, appended to a theme element, removed in a finally. Moon
     Bundle's tree is not involved.
     ---------------------------------------------------------------------- */

  const GALLERY_SELECTORS = [
    "media-gallery",
    ".product__media-gallery",
    ".product-media-gallery",
    ".product__media-list",
    ".product-gallery",
    ".product__media-wrapper"
  ];

  function findGallery() {
    for (const selector of GALLERY_SELECTORS) {
      const nodes = Array.from(document.querySelectorAll(selector));

      for (const node of nodes) {
        const rect = node.getBoundingClientRect();

        if (rect.width > 120 && rect.height > 120 && node.querySelector("img")) {
          return node;
        }
      }
    }

    return null;
  }

  function biggestImage(container) {
    let best = null;
    let bestArea = 0;

    Array.from(container.querySelectorAll("img")).forEach(img => {
      const rect = img.getBoundingClientRect();
      const area = rect.width * rect.height;

      if (area > bestArea && (img.currentSrc || img.src)) {
        best = img;
        bestArea = area;
      }
    });

    return best;
  }

  function freezeGallery() {
    let container = null;
    let image = null;

    /* Never let a cosmetic nicety break the sync. If anything here throws,
       we simply do not freeze. */
    try {
      container = findGallery();
      image = container && biggestImage(container);

      if (!container || !image) return null;

      const overlay = document.createElement("div");

      overlay.className = "mb-gallery-freeze";
      overlay.setAttribute("aria-hidden", "true");
      overlay.style.backgroundImage = 'url("' + (image.currentSrc || image.src) + '")';

      const wasStatic = getComputedStyle(container).position === "static";

      if (wasStatic) container.style.position = "relative";

      container.appendChild(overlay);

      mbLog("gallery frozen");

      return { container: container, overlay: overlay, wasStatic: wasStatic };
    } catch (e) {
      mbLog("gallery freeze skipped -", e && e.message);
      return null;
    }
  }

  function unfreezeGallery(handle) {
    if (!handle) return;

    try {
      if (handle.overlay && handle.overlay.parentNode) handle.overlay.remove();
      if (handle.wasStatic && handle.container) handle.container.style.position = "";
    } catch (e) {
      mbLog("gallery unfreeze failed -", e && e.message);
    }
  }

  /* ----------------------------------------------------------------------
     Applying a band + cup choice to every unit in the tier

     Now returns true only when the page itself confirms every unit carries
     the mapped size (false otherwise). The quiz relies on that return to
     verify, not just to fire - this is the one change to this function
     beyond pure additions, needed so the quiz can tell success from
     failure on each tier.
     ---------------------------------------------------------------------- */

  async function applyMappedSizeToOffer(offer, band, cup, errorEl) {
    if (!offer || isUpdating) return false;

    cancelLateWatch(offer);

    isUpdating = true;
    document.body.classList.add("mb-bra-syncing");

    let watchArgs = null;
    let frozen = null;
    let outcome = false;

    try {
      if (errorEl) errorEl.innerHTML = "";
      if (!band || !cup) return false;

      const mappedSize = BRA_SIZE_MAP[band + cup];

      if (!mappedSize) {
        if (errorEl) {
          errorEl.innerHTML = '<span class="mb-global-bra-error">This combination is not available</span>';
        }

        return false;
      }

      frozen = freezeGallery();

      renderSizeRows(offer, true);

      /* Read every unit's colour BEFORE touching the size. Whatever Moon
         Bundle does to the rows next, we can put them back. */
      const savedColours = getRows(offer).map(readColour);

      savedColours.forEach((c, i) => {
        if (c.how === "unreadable" || c.how === "none") {
          mbLog("WARNING: bra", i + 1, "colour cannot be read, it will not be restored");
        }
      });

      const startedAt = Date.now();

      const result = await reconcileUntilStable(offer, mappedSize, savedColours);

      mbLog("total elapsed", (Date.now() - startedAt) + "ms");

      if (errorEl) errorEl.innerHTML = "";

      /* Final word comes from the page, not from the loop's opinion of
         itself. Anything that disagrees is named. */
      const dropped = [];

      getRows(offer).forEach((row, index) => {
        const wanted = savedColours[index];

        if (!wanted || wanted.how === "none" || wanted.how === "unreadable") return;
        if (colourMatches(row, wanted)) return;

        dropped.push("#" + (index + 1));
      });

      renderSizeRows(offer, false);

      mbLog("final check - dropped", dropped.length ? dropped.join(", ") : "none");

      if (!result.sizeOk && errorEl) {
        errorEl.innerHTML =
          '<span class="mb-global-bra-error">We could not set ' + mappedSize +
          ' on every bra. Please check each one above.</span>';

        offer.classList.add("mb-show-native-size");
      } else if (dropped.length && errorEl) {
        errorEl.innerHTML =
          '<span class="mb-global-bra-error">' + dropped.join(", ") +
          ' went back to the default colour when the size changed. Please pick ' +
          (dropped.length === 1 ? 'it' : 'them') + ' again above.</span>';
      }

      outcome = !!result.sizeOk;
      watchArgs = { size: mappedSize, colours: savedColours };
    } finally {
      renderSizeRows(offer, false);
      unfreezeGallery(frozen);

      document.body.classList.remove("mb-bra-syncing");
      isUpdating = false;

      if (watchArgs) startLateWatch(offer, watchArgs.size, watchArgs.colours);
    }

    return outcome;
  }

  /* ----------------------------------------------------------------------
     Our own panel - the only nodes we add, and we never move theirs
     ---------------------------------------------------------------------- */

  /* A read-only echo of each unit's garment size, matching the FR build.
     These are OUR nodes inside OUR panel - the real selectors stay exactly
     where Moon Bundle built them and are never moved. */
  function renderSizeRows(offer, pending) {
    const slot = offer.querySelector(".mb-recommended-size-slot");

    if (!slot) return;

    const rows = getRows(offer);

    if (!rows.length) {
      slot.innerHTML = "";
      return;
    }

    const html = rows
      .map((row, index) => {
        const sizeSelector = classifyRow(row).size;

        const dropdown = sizeSelector &&
          (sizeSelector.querySelector(".moonbundle-custom-dropdown") || sizeSelector);

        const value = pending ? "" : (dropdown ? readDropdown(dropdown) : "");

        return (
          '<div class="mb-size-row">' +
          '<span class="mb-size-row-num">#' + (index + 1) + '</span>' +
          '<span class="mb-size-row-value' + (pending ? ' is-loading' : '') + '">' + value + '</span>' +
          '</div>'
        );
      })
      .join("");

    /* Only touch the DOM when something actually changed. The observer fires
       constantly and a needless innerHTML write would retrigger it. */
    if (slot.innerHTML !== html) slot.innerHTML = html;
  }


  function buildGlobalSelectorUI(offer) {
    const ui = document.createElement("div");
    ui.className = "mb-global-bra-ui";

    ui.innerHTML =
      '<div class="mb-global-bra-header">' +
        '<div class="mb-global-bra-title">Choose your size</div>' +
        '<button type="button" class="mb-size-guide-trigger">Size guide</button>' +
      '</div>' +

      '<div class="mb-global-bra-grid">' +
        '<div class="mb-global-bra-field">' +
          '<div class="mb-global-bra-label">Band size</div>' +
          '<select class="mb-global-band">' +
            '<option value="">Band size</option>' +
            BAND_OPTIONS.map(v => '<option value="' + v + '">' + v + '</option>').join("") +
          '</select>' +
        '</div>' +

        '<div class="mb-global-bra-field">' +
          '<div class="mb-global-bra-label">Cup size</div>' +
          '<select class="mb-global-cup">' +
            '<option value="">Cup size</option>' +
            CUP_OPTIONS.map(v => '<option value="' + v + '">' + v + '</option>').join("") +
          '</select>' +
        '</div>' +
      '</div>' +

      '<div class="mb-recommended-size-slot" aria-hidden="true"></div>' +
      '<div class="mb-global-bra-error-wrap"></div>';

    const guideBtn = ui.querySelector(".mb-size-guide-trigger");
    const bandSelect = ui.querySelector(".mb-global-band");
    const cupSelect = ui.querySelector(".mb-global-cup");
    const errorEl = ui.querySelector(".mb-global-bra-error-wrap");

    guideBtn.addEventListener("click", openSizeGuideModal);

    const onChange = () => {
      /* A manual pick replaces the quiz result from here on. */
      if (bandSelect.value && cupSelect.value) {
        MB_QUIZ_APPLIED.band = bandSelect.value;
        MB_QUIZ_APPLIED.cup = cupSelect.value;
      }

      applyMappedSizeToOffer(offer, bandSelect.value, cupSelect.value, errorEl);
    };

    bandSelect.addEventListener("change", onChange);
    cupSelect.addEventListener("change", onChange);

    return ui;
  }

  function injectGlobalSelectorIntoOffer(offer) {
    if (!offer || offer.querySelector(".mb-global-bra-ui")) return;

    const variantsBox = offer.querySelector(".moonbundle-variants-box");

    if (!variantsBox) return;
    if (!getRows(offer).length) return;

    /* Appending a new last child is the least disruptive thing we can do to
       a tree we do not own. We never remove or reorder their children. */
    variantsBox.appendChild(buildGlobalSelectorUI(offer));
  }

  /* ----------------------------------------------------------------------
     Styles
     ---------------------------------------------------------------------- */

  function injectStyles() {
    if (stylesInjected) return;

    stylesInjected = true;

    const style = document.createElement("style");
    style.id = "mb-bra-global-styles";

    style.textContent = `
      .mb-global-bra-ui{
        position:relative;
        width:100%;
        margin:12px 0 0;
        padding:12px;
        border:1px solid rgba(0,0,0,.14);
        border-radius:12px;
        background:${PANEL_BG};
        box-sizing:border-box;
      }

      .mb-global-bra-header{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:10px;
        margin-bottom:10px;
      }

      .mb-global-bra-title{
        font-size:14px;
        font-weight:700;
        color:#111;
        line-height:1.2;
        margin:0;
      }

      .mb-size-guide-trigger{
        appearance:none;
        -webkit-appearance:none;
        border:0;
        background:transparent;
        color:#111;
        padding:0;
        margin:0;
        font-size:11px;
        font-weight:700;
        line-height:1.2;
        text-decoration:underline;
        cursor:pointer;
        white-space:nowrap;
      }

      .mb-global-bra-grid{
        display:grid;
        grid-template-columns:1fr 1fr;
        gap:8px;
        width:100%;
      }

      .mb-global-bra-field{
        position:relative;
        display:flex;
        flex-direction:column;
        gap:4px;
        min-width:0;
      }

      .mb-global-bra-label{
        font-size:11px;
        font-weight:600;
        color:#111;
        line-height:1.2;
      }

      .mb-global-bra-field select{
        width:100%;
        height:36px;
        border:1px solid #111;
        border-radius:8px;
        background:#fff;
        color:#111;
        padding:0 28px 0 10px;
        font-size:13px;
        font-weight:500;
        outline:none;
        appearance:none;
        -webkit-appearance:none;
        box-shadow:none;
        cursor:pointer;
      }

      .mb-global-bra-field::after{
        content:"";
        position:absolute;
        right:10px;
        bottom:13px;
        width:10px;
        height:10px;
        pointer-events:none;
        background:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath fill='%23000' d='M6 9L1 4h10z'/%3E%3C/svg%3E") no-repeat center;
        background-size:contain;
      }


      /* The size selector stays exactly where Moon Bundle built it. We only
         hide it, so its DOM position never changes. */
      .moonbundle-option-selector.mb-is-size{
        display:none !important;
      }

      .mb-show-native-size .moonbundle-option-selector.mb-is-size{
        display:block !important;
      }

      .mb-global-bra-error{
        display:block;
        color:#7a1810;
        font-weight:600;
        font-size:12px;
        margin-top:8px;
        line-height:1.35;
      }

      .moonbundle-variant-row{
        margin-bottom:10px !important;
      }

      .moonbundle-variant-selectors{
        display:block !important;
        width:100% !important;
      }

      .moonbundle-swatch-buttons{
        display:flex !important;
        gap:8px !important;
        flex-wrap:wrap !important;
        align-items:center !important;
      }

      /* Her colours stay on screen the entire time. Only the size rows below
         show that anything is happening. Hiding the swatches was the wrong
         call: it removed the one thing she wanted to keep looking at. */
      body.mb-bra-syncing .moonbundle-variant-row{
        pointer-events:none;
        opacity:.9;
      }

      @keyframes mb-bra-sweep{
        from{background-position:-60% 0;}
        to{background-position:160% 0;}
      }

      .mb-recommended-size-slot{
        display:flex;
        flex-direction:column;
        gap:7px;
        margin-top:10px;
      }

      .mb-recommended-size-slot:empty{
        display:none;
      }

      .mb-size-row{
        display:grid;
        grid-template-columns:26px 1fr;
        align-items:center;
        gap:8px;
        width:100%;
      }

      .mb-size-row-num{
        font-size:12px;
        font-weight:700;
        color:#111;
        opacity:.8;
      }

      .mb-size-row-value{
        position:relative;
        display:flex;
        align-items:center;
        height:34px;
        padding:0 10px;
        border:1px solid rgba(0,0,0,.25);
        border-radius:8px;
        background:#fff;
        color:#111;
        font-size:13px;
        font-weight:600;
        line-height:1;
        overflow:hidden;
        box-sizing:border-box;
      }

      .mb-size-row-value.is-loading::after{
        content:"";
        position:absolute;
        inset:0;
        background:rgba(0,0,0,.05);
        background-image:linear-gradient(90deg,transparent,rgba(0,0,0,.08),transparent);
        background-size:60% 100%;
        background-repeat:no-repeat;
        animation:mb-bra-sweep 1s linear infinite;
      }

      .mb-size-row-value.is-warn{
        border-color:#7a1810;
        color:#7a1810;
      }

      @media (prefers-reduced-motion:reduce){
        .mb-size-row-value.is-loading::after{
          animation:none;
        }
      }

      .mb-gallery-freeze{
        position:absolute;
        inset:0;
        z-index:4;
        background-color:#FAF8F4;
        background-repeat:no-repeat;
        background-position:center;
        background-size:contain;
        pointer-events:none;
      }

      .mb-global-bra-status{
        display:block;
        color:#3b2f16;
        font-weight:600;
        font-size:12px;
        margin-top:8px;
        line-height:1.35;
      }


      .mb-size-guide-modal{
        position:fixed;
        inset:0;
        z-index:999999;
        display:none;
        align-items:center;
        justify-content:center;
        padding:18px;
        background:rgba(0,0,0,.58);
        box-sizing:border-box;
      }

      .mb-size-guide-modal.is-open{
        display:flex;
      }

      .mb-size-guide-dialog{
        position:relative;
        width:min(760px,100%);
        max-height:92vh;
        overflow:hidden;
        background:#fff;
        border-radius:18px;
        padding:16px;
        box-sizing:border-box;
        box-shadow:0 20px 60px rgba(0,0,0,.28);
      }

      .mb-size-guide-top{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
        margin-bottom:12px;
      }

      .mb-size-guide-title{
        font-size:18px;
        font-weight:800;
        color:#111;
        margin:0;
        line-height:1.2;
      }

      .mb-size-guide-close{
        border:0;
        background:#111;
        color:#fff;
        width:32px;
        height:32px;
        border-radius:50%;
        font-size:20px;
        line-height:1;
        cursor:pointer;
        display:flex;
        align-items:center;
        justify-content:center;
        flex-shrink:0;
      }

      .mb-size-guide-tabs{
        display:grid;
        grid-template-columns:1fr 1fr;
        gap:8px;
        margin-bottom:12px;
      }

      .mb-size-guide-tab{
        border:1px solid rgba(0,0,0,.18);
        background:#f7f7f7;
        color:#111;
        border-radius:10px;
        padding:10px 8px;
        font-size:13px;
        font-weight:800;
        line-height:1.15;
        cursor:pointer;
      }

      .mb-size-guide-tab.is-active{
        background:#111;
        color:#fff;
        border-color:#111;
      }

      .mb-size-guide-image-wrap{
        width:100%;
        max-height:calc(92vh - 130px);
        overflow:auto;
        border-radius:12px;
        background:${GUIDE_BG};
      }

      .mb-size-guide-img{
        display:none;
        width:100%;
        height:auto;
        max-width:100%;
        border-radius:12px;
      }

      .mb-size-guide-img.is-active{
        display:block;
      }

      @media (max-width:640px){
        .mb-global-bra-field select{
          height:34px;
          font-size:12px;
        }

        .mb-size-guide-modal{
          padding:10px;
        }

        .mb-size-guide-dialog{
          width:100%;
          max-height:90vh;
          padding:12px;
          border-radius:14px;
        }

        .mb-size-guide-title{
          font-size:16px;
        }

        .mb-size-guide-tabs{
          gap:6px;
        }

        .mb-size-guide-tab{
          font-size:11px;
          padding:9px 6px;
        }

        .mb-size-guide-image-wrap{
          max-height:calc(90vh - 125px);
        }
      }
    `;

    document.head.appendChild(style);
  }

  /* ----------------------------------------------------------------------
     Size guide modal
     ---------------------------------------------------------------------- */

  function ensureSizeGuideModal() {
    let modal = document.getElementById("mb-size-guide-modal");

    if (modal) return modal;

    modal = document.createElement("div");
    modal.id = "mb-size-guide-modal";
    modal.className = "mb-size-guide-modal";
    modal.setAttribute("aria-hidden", "true");

    modal.innerHTML =
      '<div class="mb-size-guide-dialog" role="dialog" aria-modal="true" aria-label="Size guide">' +
        '<div class="mb-size-guide-top">' +
          '<h3 class="mb-size-guide-title">Size guide</h3>' +
          '<button type="button" class="mb-size-guide-close" aria-label="Close" data-mb-size-guide-close>&times;</button>' +
        '</div>' +

        '<div class="mb-size-guide-tabs">' +
          '<button type="button" class="mb-size-guide-tab is-active" data-guide-tab="en">US / UK</button>' +
          '<button type="button" class="mb-size-guide-tab" data-guide-tab="aus">Australia / New Zealand</button>' +
        '</div>' +

        '<div class="mb-size-guide-image-wrap">' +
          '<img class="mb-size-guide-img is-active" data-guide-img="en" src="' + SIZE_GUIDE_IMAGES.en + '" alt="US / UK size guide" loading="lazy">' +
          '<img class="mb-size-guide-img" data-guide-img="aus" src="' + SIZE_GUIDE_IMAGES.aus + '" alt="Australia / New Zealand size guide" loading="lazy">' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);

    modal.querySelectorAll("[data-mb-size-guide-close]").forEach(btn => {
      btn.addEventListener("click", closeSizeGuideModal);
    });

    modal.querySelectorAll("[data-guide-tab]").forEach(tab => {
      tab.addEventListener("click", () => {
        const target = tab.getAttribute("data-guide-tab");

        modal.querySelectorAll("[data-guide-tab]").forEach(btn => {
          btn.classList.toggle("is-active", btn === tab);
        });

        modal.querySelectorAll("[data-guide-img]").forEach(img => {
          img.classList.toggle("is-active", img.getAttribute("data-guide-img") === target);
        });
      });
    });

    modal.addEventListener("click", event => {
      if (event.target === modal) closeSizeGuideModal();
    });

    document.addEventListener("keydown", event => {
      if (event.key === "Escape") closeSizeGuideModal();
    });

    return modal;
  }

  function openSizeGuideModal() {
    const modal = ensureSizeGuideModal();

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
  }

  function closeSizeGuideModal() {
    const modal = document.getElementById("mb-size-guide-modal");

    if (!modal) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
  }

  /* ----------------------------------------------------------------------
     Brand font matching, used by the quiz modal below.

     A node appended straight to <body> doesn't inherit the theme's brand
     font if that font is set on a scoped wrapper rather than on body
     itself. Read the real font and size off our own panel (already
     correctly styled, since it lives inside the theme's content tree) and
     apply them explicitly instead of guessing.
     ---------------------------------------------------------------------- */

  function mbBrandFont() {
    const source =
      document.querySelector(".mb-global-bra-title") ||
      document.querySelector(".moonbundle-option-wrapper") ||
      document.body;

    const family = getComputedStyle(source).fontFamily;

    return family && family !== "" ? family : "inherit";
  }

  function mbBrandFontSize() {
    const size = getComputedStyle(document.body).fontSize;

    return size && size !== "" ? size : "16px";
  }

  /* ----------------------------------------------------------------------
     "Find my size" quiz - 4 questions, same logic as the LaceLift build,
     wired into this file's own panel (.mb-global-band / .mb-global-cup)
     instead of moving anything Moon Bundle owns.
     ---------------------------------------------------------------------- */

  const MB_QUIZ_STATE = {
    band: "",
    cup: "",
    cupFit: "",
    bandFit: "",
    hooks: "",
    step: 1
  };

  function mbQuizResolveSize() {
    const bandIdx = BAND_OPTIONS.indexOf(MB_QUIZ_STATE.band);
    const cupIdx = CUP_OPTIONS.indexOf(MB_QUIZ_STATE.cup);

    if (bandIdx === -1 || cupIdx === -1) return null;

    /* Band: the tightest hook row means the band is already at its max, so
       it is too loose. The loosest hook row means the opposite. */
    let bandDelta = 0;

    if (MB_QUIZ_STATE.bandFit === "tight") bandDelta += 1;
    if (MB_QUIZ_STATE.bandFit === "loose") bandDelta -= 1;
    if (MB_QUIZ_STATE.hooks === "closest") bandDelta -= 1;
    if (MB_QUIZ_STATE.hooks === "farthest") bandDelta += 1;

    if (bandDelta > 1) bandDelta = 1;
    if (bandDelta < -1) bandDelta = -1;

    /* Sister size: a smaller band needs a bigger cup for the same volume. */
    let cupDelta = -bandDelta;

    if (MB_QUIZ_STATE.cupFit === "small") cupDelta += 1;
    if (MB_QUIZ_STATE.cupFit === "big") cupDelta -= 1;

    let newBandIdx = bandIdx + bandDelta;
    let newCupIdx = cupIdx + cupDelta;

    if (newBandIdx < 0) newBandIdx = 0;
    if (newBandIdx > BAND_OPTIONS.length - 1) newBandIdx = BAND_OPTIONS.length - 1;
    if (newCupIdx < 0) newCupIdx = 0;
    if (newCupIdx > CUP_OPTIONS.length - 1) newCupIdx = CUP_OPTIONS.length - 1;

    const band = BAND_OPTIONS[newBandIdx];
    const cup = CUP_OPTIONS[newCupIdx];

    /* If the cell is empty, follow the product's rounding direction first,
       then fall back the other way, so she is never left with no match at
       all. */
    let mapped = BRA_SIZE_MAP[band + cup];
    let resolvedCup = cup;

    const dir = ROUNDING === "down" ? -1 : 1;

    for (let i = newCupIdx + dir; i >= 0 && i < CUP_OPTIONS.length && !mapped; i += dir) {
      mapped = BRA_SIZE_MAP[band + CUP_OPTIONS[i]];
      if (mapped) resolvedCup = CUP_OPTIONS[i];
    }

    for (let i = newCupIdx - dir; i >= 0 && i < CUP_OPTIONS.length && !mapped; i -= dir) {
      mapped = BRA_SIZE_MAP[band + CUP_OPTIONS[i]];
      if (mapped) resolvedCup = CUP_OPTIONS[i];
    }

    const cupAdjusted = resolvedCup !== cup;
    cupDelta = CUP_OPTIONS.indexOf(resolvedCup) - cupIdx;

    return {
      band: band,
      cup: resolvedCup,
      size: mapped || "",
      bandDelta: bandDelta,
      cupDelta: cupDelta,
      cupAdjusted: cupAdjusted,
      originalBand: MB_QUIZ_STATE.band,
      originalCup: MB_QUIZ_STATE.cup
    };
  }

  function mbQuizReasons(result) {
    const out = [];

    if (result.bandDelta !== 0) {
      let why;

      if (result.bandDelta < 0) {
        why = MB_QUIZ_STATE.hooks === "closest"
          ? "you're already on the tightest hook. The band can't tighten any further, and it will only stretch out more with wear."
          : "you told us it rides up your back.";
      } else {
        why = MB_QUIZ_STATE.bandFit === "tight"
          ? "you told us it feels too tight."
          : "you're already on the loosest hook, so there's no room left to give.";
      }

      out.push({
        label: "Band " + result.originalBand + " \u2192 " + result.band,
        text: why
      });
    }

    if (result.cupDelta !== 0 || result.cupAdjusted) {
      let why;

      if (result.cupAdjusted) {
        why = "that cup doesn't exist at this band in our range, so we've picked the closest match on the chart.";
      } else if (MB_QUIZ_STATE.cupFit === "small") {
        why = "you told us there was some spillage.";
      } else if (MB_QUIZ_STATE.cupFit === "big") {
        why = "you told us the cup gapes.";
      } else if (result.bandDelta < 0) {
        why = "a smaller band needs a bigger cup for the same volume. Your chest hasn't changed, just the structure sitting closer to it.";
      } else {
        why = "a bigger band needs a smaller cup for the same volume. Your chest hasn't changed, just the structure sitting further out.";
      }

      out.push({
        label: "Cup " + result.originalCup + " \u2192 " + result.cup,
        text: why
      });
    }

    if (!out.length) {
      out.push({
        label: "Size confirmed",
        text: "your current bra fits you well, so we're keeping the same match."
      });
    }

    return out;
  }

  function mbQuizInjectStyles() {
    if (document.getElementById("mb-quiz-styles")) return;

    const style = document.createElement("style");
    style.id = "mb-quiz-styles";
    style.textContent = `
      .mb-quiz-bar{
        display:flex;
        justify-content:space-between;
        align-items:center;
        gap:12px;
        margin:0 0 14px;
        padding:0 2px;
      }
      .mb-quiz-bar-btn{
        appearance:none;
        -webkit-appearance:none;
        border:0;
        background:none;
        padding:0;
        margin:0;
        font-size:1em;
        font-weight:700;
        color:#111;
        text-decoration:underline;
        cursor:pointer;
      }
      .mb-quiz-bar-guide{
        font-weight:600;
        color:#4A3B28;
      }
      .mb-quiz-modal{position:fixed;inset:0;display:none;z-index:1000000;}
      .mb-quiz-modal.is-open{display:block;}
      .mb-quiz-overlay{position:absolute;inset:0;background:rgba(0,0,0,.55);}
      .mb-quiz-box{
        position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);
        width:92%;max-width:430px;max-height:88vh;overflow-y:auto;
        background:#FFFDF9;border-radius:16px;padding:22px 20px 20px;
        box-sizing:border-box;
        font-family:inherit;font-size:16px;color:#1C1310;
      }
      .mb-quiz-steps{display:flex;gap:5px;margin-bottom:16px;}
      .mb-quiz-steps span{flex:1;height:3px;border-radius:2px;background:#E9DFC9;}
      .mb-quiz-steps span.done{background:#1C1310;}
      .mb-quiz-close{
        position:absolute;top:14px;right:14px;width:30px;height:30px;
        border:0;border-radius:999px;background:none;color:#6B5A52;
        font-size:1.69em;line-height:1;cursor:pointer;
      }
      .mb-quiz-count{font-size:0.92em;color:#8A7168;margin:0 0 6px;}
      .mb-quiz-q{font-size:1.62em;font-weight:700;line-height:1.25;margin:0 0 6px;}
      .mb-quiz-sub{font-size:1.04em;color:#6B5A52;margin:0 0 16px;line-height:1.4;}
      .mb-quiz-label{font-size:0.92em;color:#6B5A52;margin:0 0 7px;}
      .mb-quiz-grid{display:grid;gap:7px;margin-bottom:16px;}
      .mb-quiz-grid.bands{grid-template-columns:repeat(5,1fr);}
      .mb-quiz-grid.cups{grid-template-columns:repeat(4,1fr);}
      .mb-quiz-chip{
        appearance:none;border:1px solid #E2D6C4;background:#fff;
        border-radius:9px;padding:10px 2px;font:inherit;font-size:1em;
        text-align:center;
        cursor:pointer;color:#1C1310;transition:background .12s,border-color .12s;
      }
      .mb-quiz-chip[aria-pressed="true"]{background:#1C1310;border-color:#1C1310;color:#fff;font-weight:600;}
      .mb-quiz-opt{
        display:flex;gap:11px;align-items:flex-start;width:100%;text-align:left;
        border:1px solid #E2D6C4;background:#fff;border-radius:11px;
        padding:13px 14px;margin-bottom:8px;cursor:pointer;font:inherit;
      }
      .mb-quiz-opt[aria-pressed="true"]{border-color:#1C1310;border-width:2px;padding:12px 13px;}
      .mb-quiz-dot{
        flex:0 0 auto;width:17px;height:17px;border-radius:50%;
        border:1.5px solid #CBBDA9;margin-top:2px;position:relative;
      }
      .mb-quiz-opt[aria-pressed="true"] .mb-quiz-dot{border-color:#1C1310;}
      .mb-quiz-opt[aria-pressed="true"] .mb-quiz-dot::after{
        content:"";position:absolute;inset:3px;border-radius:50%;background:#1C1310;
      }
      .mb-quiz-opt b{display:block;font-size:1.12em;font-weight:700;margin-bottom:2px;}
      .mb-quiz-opt span.d{display:block;font-size:0.96em;color:#6B5A52;line-height:1.35;}
      .mb-quiz-nav{display:flex;align-items:center;gap:12px;margin-top:16px;}
      .mb-quiz-back{
        background:none;border:0;padding:6px 2px;font:inherit;font-size:1.04em;
        color:#6B5A52;cursor:pointer;
      }
      .mb-quiz-next{
        flex:1;appearance:none;border:0;border-radius:10px;
        background:#1C1310;color:#fff;font:inherit;font-size:1.15em;font-weight:600;
        text-align:center;
        padding:14px;cursor:pointer;
      }
      .mb-quiz-next[disabled]{background:#DCCFB9;color:#fff;cursor:default;}
      .mb-quiz-result{text-align:center;}
      .mb-quiz-result .cap{font-size:1.08em;color:#6B5A52;margin:0 0 14px;}
      .mb-quiz-size{
        border:1px dashed #CBBDA9;border-radius:10px;
        padding:22px 12px;margin:0 auto 14px;max-width:270px;background:#fff;
      }
      .mb-quiz-size .brand{font-size:0.96em;color:#8A7168;margin:0 0 8px;}
      .mb-quiz-size .val{font-size:3.54em;font-weight:700;line-height:1;margin:0;letter-spacing:-.01em;}
      .mb-quiz-size .garment{font-size:1em;color:#6B5A52;margin:10px 0 0;}
      .mb-quiz-size .garment b{color:#1C1310;font-weight:700;}
      .mb-quiz-result .spec{font-size:1.04em;color:#6B5A52;margin:0;}
      .mb-quiz-result .spec b{color:#1C1310;font-weight:700;}
      .mb-quiz-why{
        text-align:left;border-top:1px solid #EFE6D6;
        margin-top:18px;padding-top:16px;
      }
      .mb-quiz-why h4{font-size:1.08em;color:#6B5A52;font-weight:500;margin:0 0 12px;}
      .mb-quiz-why ul{list-style:none;margin:0;padding:0;}
      .mb-quiz-why li{
        position:relative;padding-left:16px;margin:0 0 12px;
        font-size:1.04em;line-height:1.5;color:#4A3B2C;
      }
      .mb-quiz-why li::before{
        content:"";position:absolute;left:0;top:10px;
        width:8px;height:1.5px;background:#B4A387;
      }
      .mb-quiz-why li b{color:#1C1310;font-weight:700;}
      .mb-quiz-why .rule{
        margin:14px 0 0;font-size:0.96em;color:#8A7168;font-style:italic;
      }
      .mb-quiz-result .mb-quiz-next{width:100%;margin-top:18px;}
      .mb-quiz-restart{
        display:block;margin:14px auto 0;background:none;border:0;
        font:inherit;font-size:1.04em;color:#6B5A52;text-decoration:underline;cursor:pointer;
      }
      @media (max-width:400px){
        .mb-quiz-grid.cups{grid-template-columns:repeat(4,1fr);}
        .mb-quiz-grid.bands{grid-template-columns:repeat(4,1fr);}
        .mb-quiz-q{font-size:1.46em;}
      }
    `;

    document.head.appendChild(style);
  }

  function ensureQuizModal() {
    let modal = document.getElementById("mb-quiz-modal");

    if (modal) return modal;

    modal = document.createElement("div");
    modal.id = "mb-quiz-modal";
    modal.className = "mb-quiz-modal";
    modal.setAttribute("aria-hidden", "true");

    modal.innerHTML =
      '<div class="mb-quiz-overlay"></div>' +
      '<div class="mb-quiz-box" role="dialog" aria-modal="true" aria-label="Find my size">' +
        '<button type="button" class="mb-quiz-close" aria-label="Close">&times;</button>' +
        '<div class="mb-quiz-body"></div>' +
      '</div>';

    const quizBoxEl = modal.querySelector(".mb-quiz-box");
    quizBoxEl.style.fontFamily = mbBrandFont();
    quizBoxEl.style.fontSize = mbBrandFontSize();

    document.body.appendChild(modal);

    modal.querySelector(".mb-quiz-close").addEventListener("click", mbQuizClose);
    modal.querySelector(".mb-quiz-overlay").addEventListener("click", mbQuizClose);

    document.addEventListener("keydown", event => {
      if (event.key === "Escape") mbQuizClose();
    });

    return modal;
  }

  function mbQuizClose() {
    const modal = document.getElementById("mb-quiz-modal");

    if (!modal) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
  }

  function mbQuizOpen() {
    mbQuizInjectStyles();

    const modal = ensureQuizModal();
    const box = modal.querySelector(".mb-quiz-box");

    if (box) {
      box.style.fontFamily = mbBrandFont();
      box.style.fontSize = mbBrandFontSize();
    }

    MB_QUIZ_STATE.step = 1;

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");

    mbQuizRender();
  }

  function mbQuizStepsBar(step) {
    let out = '<div class="mb-quiz-steps">';

    for (let i = 1; i <= 4; i++) {
      out += '<span class="' + (i <= step ? "done" : "") + '"></span>';
    }

    return out + "</div>";
  }

  function mbQuizOption(field, value, title, desc) {
    const on = MB_QUIZ_STATE[field] === value;

    return '<button type="button" class="mb-quiz-opt" data-field="' + field + '" data-value="' + value + '" aria-pressed="' + on + '">' +
      '<span class="mb-quiz-dot"></span><span><b>' + title + '</b>' +
      (desc ? '<span class="d">' + desc + '</span>' : "") + '</span></button>';
  }

  function mbQuizNav(value, label) {
    return '<div class="mb-quiz-nav">' +
      '<button type="button" class="mb-quiz-back" data-back>Back</button>' +
      '<button type="button" class="mb-quiz-next" data-next ' + (value ? "" : "disabled") + '>' +
      (label || "Continue") + '</button></div>';
  }

  function mbQuizRender() {
    const modal = ensureQuizModal();
    const body = modal.querySelector(".mb-quiz-body");
    const s = MB_QUIZ_STATE;

    if (s.step === 1) {
      body.innerHTML =
        mbQuizStepsBar(1) +
        '<p class="mb-quiz-count">Question 1 / 4</p>' +
        '<p class="mb-quiz-q">What size do you currently wear?</p>' +
        '<p class="mb-quiz-sub">Think of the bra you\u2019re most comfortable in.</p>' +
        '<p class="mb-quiz-label">Band size</p>' +
        '<div class="mb-quiz-grid bands">' +
          BAND_OPTIONS.map(v =>
            '<button type="button" class="mb-quiz-chip" data-band="' + v + '" aria-pressed="' + (s.band === v) + '">' + v + '</button>'
          ).join("") +
        '</div>' +
        '<p class="mb-quiz-label">Cup size</p>' +
        '<div class="mb-quiz-grid cups">' +
          CUP_OPTIONS.map(v =>
            '<button type="button" class="mb-quiz-chip" data-cup="' + v + '" aria-pressed="' + (s.cup === v) + '">' + v + '</button>'
          ).join("") +
        '</div>' +
        '<div class="mb-quiz-nav"><button type="button" class="mb-quiz-next" data-next ' +
          (s.band && s.cup ? "" : "disabled") + '>Continue</button></div>';
    }

    if (s.step === 2) {
      body.innerHTML =
        mbQuizStepsBar(2) +
        '<p class="mb-quiz-count">Question 2 / 4</p>' +
        '<p class="mb-quiz-q">How does the cup fit?</p>' +
        '<p class="mb-quiz-sub">Same bra as question 1.</p>' +
        mbQuizOption("cupFit", "small", "Too small", "There\u2019s spillage at the top or sides.") +
        mbQuizOption("cupFit", "perfect", "Just right", "No gaping, no spillage.") +
        mbQuizOption("cupFit", "big", "Too big", "The cup gapes or wrinkles.") +
        mbQuizNav(s.cupFit);
    }

    if (s.step === 3) {
      body.innerHTML =
        mbQuizStepsBar(3) +
        '<p class="mb-quiz-count">Question 3 / 4</p>' +
        '<p class="mb-quiz-q">How does the band feel?</p>' +
        '<p class="mb-quiz-sub">The band does most of the support work.</p>' +
        mbQuizOption("bandFit", "tight", "Too tight", "It digs in or feels restrictive.") +
        mbQuizOption("bandFit", "perfect", "Just right", "Sits level and stays put.") +
        mbQuizOption("bandFit", "loose", "Too loose", "It rides up your back.") +
        mbQuizNav(s.bandFit);
    }

    if (s.step === 4) {
      body.innerHTML =
        mbQuizStepsBar(4) +
        '<p class="mb-quiz-count">Question 4 / 4</p>' +
        '<p class="mb-quiz-q">Which hook row do you fasten it on?</p>' +
        '<p class="mb-quiz-sub">This tells us how much room you have left.</p>' +
        mbQuizOption("hooks", "closest", "The tightest", "The innermost hooks.") +
        mbQuizOption("hooks", "medium", "The middle", "The middle row.") +
        mbQuizOption("hooks", "farthest", "The loosest", "The outermost hooks.") +
        mbQuizNav(s.hooks, "See my size");
    }

    if (s.step === 5) {
      const result = mbQuizResolveSize();

      if (!result || !result.size) {
        body.innerHTML =
          '<div class="mb-quiz-result"><p class="mb-quiz-q">No match found</p>' +
          '<p class="mb-quiz-sub">Check the size guide or get in touch and we\u2019ll help you find your size.</p>' +
          '<button type="button" class="mb-quiz-restart" data-restart>Start over</button></div>';

        mbQuizBind(body);
        return;
      }

      body.innerHTML =
        '<div class="mb-quiz-result">' +
          '<p class="cap">Your recommended size</p>' +
          '<div class="mb-quiz-size">' +
            '<p class="brand">Celyssia</p>' +
            '<p class="val">' + result.band + result.cup + '</p>' +
            '<p class="garment">' + PRODUCT_LABEL + ' size: <b>' + result.size + '</b></p>' +
          '</div>' +
          '<p class="spec">You told us you currently wear <b>' + result.originalBand + result.originalCup + '</b>.</p>' +
          '<div class="mb-quiz-why"><h4>Why this size?</h4><ul>' +
            mbQuizReasons(result).map(r =>
              '<li><b>' + r.label + '</b>: ' + r.text + '</li>'
            ).join("") +
          '</ul>' +
          (ROUNDING_TEXT ? '<p class="rule">' + ROUNDING_TEXT + '</p>' : '') +
          '</div>' +
          '<button type="button" class="mb-quiz-next" data-apply>Use this size</button>' +
          '<button type="button" class="mb-quiz-restart" data-restart>Start over</button>' +
        '</div>';
    }

    mbQuizBind(body);
  }

  function mbQuizBind(body) {
    body.querySelectorAll("[data-band]").forEach(el => {
      el.addEventListener("click", () => {
        MB_QUIZ_STATE.band = el.getAttribute("data-band");
        mbQuizRender();
      });
    });

    body.querySelectorAll("[data-cup]").forEach(el => {
      el.addEventListener("click", () => {
        MB_QUIZ_STATE.cup = el.getAttribute("data-cup");
        mbQuizRender();
      });
    });

    body.querySelectorAll("[data-field]").forEach(el => {
      el.addEventListener("click", () => {
        MB_QUIZ_STATE[el.getAttribute("data-field")] = el.getAttribute("data-value");
        mbQuizRender();
      });
    });

    const next = body.querySelector("[data-next]");
    if (next) next.addEventListener("click", () => {
      MB_QUIZ_STATE.step += 1;
      mbQuizRender();
    });

    const back = body.querySelector("[data-back]");
    if (back) back.addEventListener("click", () => {
      MB_QUIZ_STATE.step -= 1;
      mbQuizRender();
    });

    const restart = body.querySelector("[data-restart]");
    if (restart) restart.addEventListener("click", () => {
      MB_QUIZ_STATE.band = "";
      MB_QUIZ_STATE.cup = "";
      MB_QUIZ_STATE.cupFit = "";
      MB_QUIZ_STATE.bandFit = "";
      MB_QUIZ_STATE.hooks = "";
      MB_QUIZ_STATE.step = 1;
      mbQuizRender();
    });

    const apply = body.querySelector("[data-apply]");
    if (apply) apply.addEventListener("click", () => {
      const result = mbQuizResolveSize();
      mbQuizClose();
      if (result) mbQuizApply(result);
    });
  }

  /* ----------------------------------------------------------------------
     Applying the quiz result to the panel(s)

     One tier at a time, the visible tier(s) first, waiting for the lock,
     then reading Moon Bundle's dropdowns back to confirm the size landed.
     Collapsed tiers can't be driven (their dropdowns don't open), so they
     are marked pending and picked up by mbQuizReapplyToFreshOffers the
     moment Moon Bundle shows them.
     ---------------------------------------------------------------------- */

  function mbOfferIsVisible(offer) {
    if (!offer || !offer.isConnected) return false;

    const rect = offer.getBoundingClientRect();

    return rect.width > 0 && rect.height > 0;
  }

  /* True when every unit in the tier shows the mapped garment size. */
  function mbOfferHasSize(offer, band, cup) {
    const mapped = normalizeText(BRA_SIZE_MAP[band + cup] || "");

    if (!mapped) return false;

    const rows = getRows(offer);

    if (!rows.length) return false;

    return rows.every(row => {
      const sizeSelector = classifyRow(row).size;

      if (!sizeSelector) return false;

      const dropdown = sizeSelector.querySelector(".moonbundle-custom-dropdown") || sizeSelector;

      return readDropdown(dropdown) === mapped;
    });
  }

  async function mbQuizApplyToUI(ui, band, cup) {
    const bandSelect = ui.querySelector(".mb-global-band");
    const cupSelect = ui.querySelector(".mb-global-cup");
    const errorEl = ui.querySelector(".mb-global-bra-error-wrap");
    const offer = ui.closest(".moonbundle-option-wrapper");

    if (!bandSelect || !cupSelect || !offer) return false;

    bandSelect.value = band;
    cupSelect.value = cup;

    /* A sync may still be running (a manual pick a second ago, or the
       previous tier). Wait for it instead of being bounced by the lock. */
    await waitFor(() => !isUpdating, 6000, 40);

    /* If the size is already there (Moon Bundle kept it through a colour
       change), there is nothing to drive. Confirm and leave her alone. */
    if (mbOfferHasSize(offer, band, cup)) return true;

    let ok = await applyMappedSizeToOffer(offer, band, cup, errorEl);

    if (!ok || !mbOfferHasSize(offer, band, cup)) {
      /* Moon Bundle may have flushed a rebuild after our pass. Let it settle
         and run one more full pass. */
      await wait(400);
      await waitFor(() => !isUpdating, 6000, 40);

      ok = await applyMappedSizeToOffer(offer, band, cup, errorEl);
    }

    return ok && mbOfferHasSize(offer, band, cup);
  }

  async function mbQuizApply(result) {
    if (!result || !result.band || !result.cup) return;

    MB_QUIZ_APPLIED.band = result.band;
    MB_QUIZ_APPLIED.cup = result.cup;

    const uis = Array.from(document.querySelectorAll(".mb-global-bra-ui"));

    const visible = uis.filter(ui => mbOfferIsVisible(ui.closest(".moonbundle-option-wrapper")));
    const hidden = uis.filter(ui => visible.indexOf(ui) === -1);

    for (const ui of visible) {
      await mbQuizApplyToUI(ui, result.band, result.cup);
    }

    for (const ui of hidden) {
      const bandSelect = ui.querySelector(".mb-global-band");
      const cupSelect = ui.querySelector(".mb-global-cup");

      if (bandSelect) bandSelect.value = result.band;
      if (cupSelect) cupSelect.value = result.cup;

      const offer = ui.closest(".moonbundle-option-wrapper");

      if (offer) offer.setAttribute("data-mb-pending", "1");
    }
  }

  /* Runs on every scan. Any visible tier whose panel has not yet received
     the chosen size - freshly rebuilt by Moon Bundle, or collapsed when the
     quiz was applied - gets it here, once. Tiers that already failed are
     left alone so the customer isn't shown the same error on repeat.

     Three guards keep this from fighting the customer. Every colour click
     makes Moon Bundle mutate the widget, which runs scan(), which could
     otherwise land here and launch a full size sync mid-click. So:

       1. Nothing runs within a short window of her touching the widget -
          her click always wins, and we look again once she has stopped.
       2. A tier whose Moon Bundle dropdowns ALREADY show the mapped size
          only gets its selects refilled. No sync, no clicks, no cascade.
       3. The same tier is never synced twice within a few seconds. */
  let mbReapplyRunning = false;
  let mbLastUserTouch = 0;
  let mbReapplyRetry = null;

  const MB_TOUCH_QUIET_MS = 1500;
  const MB_REAPPLY_COOLDOWN_MS = 4000;

  /* Programmatic .click() does not emit pointerdown, so our own corrections
     never trip this - only a real finger or mouse does. */
  document.addEventListener("pointerdown", event => {
    const target = event.target;

    if (target && target.closest && target.closest(".moonbundle-option-wrapper, .mb-global-bra-ui, .mb-quiz-bar")) {
      mbLastUserTouch = Date.now();
    }
  }, true);

  async function mbQuizReapplyToFreshOffers() {
    if (!MB_QUIZ_APPLIED.band || !MB_QUIZ_APPLIED.cup) return;
    if (mbReapplyRunning || isUpdating) return;

    const band = MB_QUIZ_APPLIED.band;
    const cup = MB_QUIZ_APPLIED.cup;

    /* A rebuilt panel (blank selects) on a tier that already carries the
       size is only cosmetic: refill the selects and do nothing else. This
       never opens a dropdown, so it can never disturb a colour. */
    document.querySelectorAll(".mb-global-bra-ui").forEach(ui => {
      const bandSelect = ui.querySelector(".mb-global-band");
      const cupSelect = ui.querySelector(".mb-global-cup");
      const offer = ui.closest(".moonbundle-option-wrapper");

      if (!bandSelect || !cupSelect || !offer) return;
      if (bandSelect.value && cupSelect.value) return;

      if (mbOfferHasSize(offer, band, cup)) {
        bandSelect.value = band;
        cupSelect.value = cup;
      }
    });

    /* Only tiers explicitly flagged when the quiz was applied (collapsed at
       the time) are ever synced from here - once each. */
    const uis = Array.from(document.querySelectorAll(".mb-global-bra-ui")).filter(ui => {
      const offer = ui.closest(".moonbundle-option-wrapper");
      const pending = offer && offer.getAttribute("data-mb-pending") === "1";
      const failed = offer && offer.classList.contains("mb-show-native-size");

      return pending && !failed && mbOfferIsVisible(offer);
    });

    if (!uis.length) return;

    /* Guard 1: she is (or just was) interacting. Come back once it's quiet;
       the observer may not fire again on its own after her last click. */
    const sinceTouch = Date.now() - mbLastUserTouch;

    if (sinceTouch < MB_TOUCH_QUIET_MS) {
      clearTimeout(mbReapplyRetry);
      mbReapplyRetry = setTimeout(mbQuizReapplyToFreshOffers, MB_TOUCH_QUIET_MS - sinceTouch + 50);
      return;
    }

    mbReapplyRunning = true;

    try {
      for (const ui of uis) {
        const offer = ui.closest(".moonbundle-option-wrapper");
        const bandSelect = ui.querySelector(".mb-global-band");
        const cupSelect = ui.querySelector(".mb-global-cup");

        offer.removeAttribute("data-mb-pending");

        /* Guard 2: the size is already on every unit. Refill the selects so
           the panel reads correctly and touch nothing else. */
        if (mbOfferHasSize(offer, band, cup)) {
          if (bandSelect) bandSelect.value = band;
          if (cupSelect) cupSelect.value = cup;
          mbLog("reapply skipped - tier already carries the size");
          continue;
        }

        /* Guard 3: this tier was synced moments ago; if it drifted again
           that fast, syncing again just keeps the shimmer going. */
        if (offer.__mbReapplyAt && Date.now() - offer.__mbReapplyAt < MB_REAPPLY_COOLDOWN_MS) {
          if (bandSelect) bandSelect.value = band;
          if (cupSelect) cupSelect.value = cup;
          mbLog("reapply skipped - cooldown");
          continue;
        }

        offer.__mbReapplyAt = Date.now();

        await mbQuizApplyToUI(ui, band, cup);
      }
    } finally {
      mbReapplyRunning = false;
    }
  }

  /* ----------------------------------------------------------------------
     Quiz trigger bar - sits ABOVE the whole Moon Bundle widget, same
     position as the LaceLift build's bar, not inside any one tier's panel.
     ---------------------------------------------------------------------- */

  function mbFindBundleRoot() {
    const offers = getOffers();

    if (!offers.length) return null;

    let root = offers[0];

    while (
      root.parentElement &&
      typeof root.parentElement.className === "string" &&
      /moonbundle/i.test(root.parentElement.className)
    ) {
      root = root.parentElement;
    }

    return root;
  }

  /* Climbing to the outermost Moon Bundle wrapper isn't precise enough:
     Moon Bundle's own template can put other content (like a "Size guide"
     accordion) above the offer tiers inside that same wrapper, and a bar
     inserted before the whole wrapper ends up above that too - not what
     "before select your offer" means. Anchor on the actual heading text
     instead, and climb only until we hit a direct child of root, so the
     bar lands on that row specifically, wherever it sits inside root. */
  function mbFindOfferHeadingRow(root) {
    if (!root) return null;

    const needle = "select your offer";
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;

    while ((node = walker.nextNode())) {
      const text = node.nodeValue && node.nodeValue.trim().toLowerCase();

      if (text && text.indexOf(needle) === 0) {
        let el = node.parentElement;

        while (el && el.parentElement && el.parentElement !== root) {
          el = el.parentElement;
        }

        return el;
      }
    }

    return null;
  }

  /* Moon Bundle renders its own "Size Guide" accordion above the offer
     tiers - it's inside the same wrapper our root climb finds, not
     something the theme customizer can touch. It duplicates our own
     "Find my size" / panel guide, so hide it by exact text match. Guarded
     against ever matching our own injected UI, and idempotent so re-runs
     from the observer don't do anything once it's already hidden. */
  function mbHideNativeSizeGuideAccordion(root) {
    if (!root) return;

    const needle = "size guide";
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;

    while ((node = walker.nextNode())) {
      const text = node.nodeValue && node.nodeValue.trim().toLowerCase();

      if (text !== needle) continue;

      const owner = node.parentElement;

      if (!owner) continue;
      if (owner.closest(".mb-global-bra-ui, .mb-quiz-bar, .mb-quiz-modal, .mb-size-guide-modal")) continue;

      let el = owner;

      while (el && el.parentElement && el.parentElement !== root) {
        el = el.parentElement;
      }

      if (el && !el.hasAttribute("data-mb-hidden")) {
        el.style.display = "none";
        el.setAttribute("data-mb-hidden", "true");
      }

      return;
    }
  }

  function mbQuizInjectTrigger() {
    mbQuizInjectStyles();

    if (document.querySelector(".mb-quiz-bar")) return;

    const root = mbFindBundleRoot();

    if (!root || !root.parentElement) return;

    const bar = document.createElement("div");
    bar.className = "mb-quiz-bar";

    const quiz = document.createElement("button");
    quiz.type = "button";
    quiz.className = "mb-quiz-bar-btn";
    quiz.textContent = "Find my size";
    quiz.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      mbQuizOpen();
    });

    const guide = document.createElement("button");
    guide.type = "button";
    guide.className = "mb-quiz-bar-btn mb-quiz-bar-guide";
    guide.textContent = "Size guide";
    guide.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      ensureSizeGuideModal();
      openSizeGuideModal();
    });

    bar.appendChild(quiz);
    bar.appendChild(guide);

    const headingRow = mbFindOfferHeadingRow(root);

    if (headingRow && headingRow.parentElement) {
      headingRow.parentElement.insertBefore(bar, headingRow);
    } else {
      root.parentElement.insertBefore(bar, root);
    }
  }

  /* ----------------------------------------------------------------------
     Boot
     ---------------------------------------------------------------------- */

  function scan() {
    injectStyles();
    mbQuizInjectStyles();
    ensureSizeGuideModal();
    ensureQuizModal();
    mbQuizInjectTrigger();
    mbHideNativeSizeGuideAccordion(mbFindBundleRoot());

    getOffers().forEach(offer => {
      injectGlobalSelectorIntoOffer(offer);
      tagSizeSelectors(offer);
      renderSizeRows(offer, false);
    });

    /* A tier Moon Bundle has just (re)built starts blank. If she already
       chose a size - quiz or by hand - put it back without asking again. */
    mbQuizReapplyToFreshOffers();
  }

  function scheduleScan() {
    /* Never re-enter while a sync is in flight: our own clicks make Moon
       Bundle mutate, which would otherwise retrigger us mid-reconcile. */
    if (isUpdating) return;

    clearTimeout(rescanTimer);
    rescanTimer = setTimeout(scan, 100);
  }

  scan();

  observer = new MutationObserver(scheduleScan);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /* Exposed only so the console can inspect state while debugging. */
  window.__mbBra = {
    scan: scan,
    observer: observer,
    readColour: readColour,
    classifyRow: classifyRow,
    getOffers: getOffers,
    getRows: getRows,

    /* Read-only. Prints what each unit actually has right now, so the page
       can be checked without trusting the chips. */
    verify: function () {
      getOffers().forEach((offer, o) => {
        const rows = getRows(offer);

        console.log("offer " + (o + 1) + " - " + rows.length + " unit(s)");

        rows.forEach((row, i) => {
          const parts = classifyRow(row);
          const sizeRoot = parts.size &&
            (parts.size.querySelector(".moonbundle-custom-dropdown") || parts.size);

          console.log(
            "  #" + (i + 1) +
            "  size " + (sizeRoot ? (readDropdown(sizeRoot) || "(blank)") : "(no size selector)") +
            "  colour " + (readColour(row).label || "(unread)") +
            "  [" + readColour(row).how + "]"
          );
        });
      });
    }
  };
})();